/*
 * @Author: syyoon@yongtrim.com 
 * @Date: 2018-07-09 18:11:06 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-09-28 22:21:45
 */


import { Injectable } from "@angular/core";
import { Store } from '@ngrx/store';
// import { Badge } from "@ionic-native/badge";
import { Socket } from "ng-socket-io";

import { AppState } from '../app/app.reducer';
import * as AuthActions from '../store/auth/auth.action';

import { User } from "../models/user.model";

import { AlertService } from "./alert.service";
import { SystemService } from "./system.service";
import { AlarmService } from "./alarm.service";
import { CategoryService } from "./category.service";
import { ProposeService } from "./propose.service";
import { CelebService } from "./celeb.service";
import { MessageService } from "./message.service";
import { ManagerService } from "./manager.service";
// import { AuthService } from "./auth.service";

const NEED_REALTIME_GUESTMODE = false;

@Injectable()
export class RealtimeService {
  private user: User;

  private isSetup = false;

  constructor(
    // private badge: Badge,
    private managerService: ManagerService,
    private messageService: MessageService,
    private celebService: CelebService,
    private proposeService: ProposeService,
    private categoryService: CategoryService,
    private systemService: SystemService,
    private alertService: AlertService,
    private alarmService: AlarmService,
    private socket: Socket,
    private store: Store<AppState>
  ) {}

  setup() {
    if (this.isSetup) {
      return;
    }
    this.isSetup = true;
    if (!NEED_REALTIME_GUESTMODE) {
      this.socket.disconnect(); // disconnect() is required!
    }

    this.socket.on("connect", () => {
      this.socket.emit("C:Auth:connect", this.user._id);
    });

    this.socket.on("disconnect", () => {});

    //
    // Broadcast message
    this.socket.on("M:System:update", data => {
      this.systemService.updatedSystems(data.doc);
    });
    this.socket.on("M:Category:update", data => {
      this.categoryService.updatedCategories(data.doc);
    });
    this.socket.on("M:Celeb:update", data => {
      this.celebService.notifyUpdatedCeleb(data.doc);
    });
    this.socket.on("M:Message:update", data => {
      this.messageService.notifyUpdatedMessage(data.doc);
    });
    this.socket.on("S:Message:update", data => {
      this.messageService.notifyUpdatedMessage(data.doc);
    });

    // this.socket.on('M:Auth:verify-email', data => {
    //   this.authService.verifiedEmail(data.checkValue);
    // });

    //
    // single message
    this.socket.on("S:Auth:logout", () => {
      this.alertService.showToastMessage("로그아웃 되었습니다.");
      this.store.dispatch(new AuthActions.Logout());
    });

    this.socket.on("S:Auth:update", data =>
      this.store.dispatch(new AuthActions.UpdateAuthReceived(data.doc))
    );

    this.socket.on("S:Push", data => {
      this.alarmService.show(data);
    });

    this.socket.on("S:Propose:update", data => {
      this.alarmService.show(data);
      this.managerService.updateMembers();
      this.proposeService.updateProposeRecieved(data.doc);
    });

    this.socket.on("S:Propose:delete", data =>
      this.proposeService.deleteProposeIdRecieved(data.id)
    );
  }

  subscribe(user: User) {
    this.user = user;
    this.socket.connect();
  }

  unsubscribe() {
    if (NEED_REALTIME_GUESTMODE) {
      if (this.user) {
        this.socket.emit("C:Auth:disconnect", this.user._id);
      }
      this.user = null;
    } else {
      this.socket.disconnect();
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/realtime.service.ts